import * as React from 'react'
import { ReactNode, useState } from 'react'
import { css } from '@emotion/react'
import {
  addingSmartroundProspectManagementStartupListUrl,
  companyUrl,
  facebookShareUrl,
  twitterShareUrl,
} from '@/lib/url'
import { colors, Tooltip } from 'plume-ui'
import { IcomoonIcon } from '../../atoms/IcomoonIcon'
import { CompanyData } from '../../../types/api'
import { useOnClickOutside } from '../../../hooks/useOnClickOutside'

type Props = {
  company: Required<CompanyData>
}

export const SubCommandMenu: React.FC<Props> = (props) => {
  const [subCommandMenuOpened, setSubCommandMenuOpened] = useState(false)

  const toggleCommandMenuOpened = () => {
    setSubCommandMenuOpened(!subCommandMenuOpened)
  }
  const refMoreButton = React.useRef<HTMLButtonElement>(null)
  const refMenus = React.useRef<HTMLUListElement>(null)

  useOnClickOutside([refMoreButton, refMenus], () =>
    setSubCommandMenuOpened(false)
  )

  return (
    <div
      className="more-button"
      css={css`
        position: relative;
      `}
    >
      <Tooltip className="more-icon-tooltip" label={'もっと見る'} place="top">
        <button
          ref={refMoreButton}
          onClick={toggleCommandMenuOpened}
          css={css`
            border: 1px solid ${colors.white00};
            border-radius: 2px;
            height: 28px;
            width: 28px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: inherit;
            background: ${subCommandMenuOpened
              ? 'rgba(0, 0, 0, 0.03)'
              : 'rgba(0,0,0,0)'};
            :hover {
              background: rgba(0, 0, 0, 0.03);
              cursor: pointer;
            }
          `}
          data-test-id="more"
        >
          <IcomoonIcon name="more-horizotal" />
        </button>
      </Tooltip>
      <ul
        ref={refMenus}
        css={css`
          margin: 0;
          padding: 0;
          display: ${subCommandMenuOpened ? 'block' : 'none'};
          position: absolute;
          right: 0;
          top: calc(100% + 12px);
          background: ${colors.white00};
          padding-block: 8px;
          border-radius: 2px;
          box-shadow:
            0px 3px 4px -2px rgba(0, 0, 0, 0.1),
            0px 1px 12px -1px rgba(0, 0, 0, 0.1);
        `}
      >
        <SubCommandMenuItem
          href={addingSmartroundProspectManagementStartupListUrl({
            name: props.company.name,
            shortname: props.company.shortname,
            corporateNumber: props.company.corporateNumber,
          })}
          dataTestId="smartround"
          css={css`
            border-bottom: 1px solid ${colors.border};
          `}
        >
          smartroundの案件リストに追加
        </SubCommandMenuItem>
        <SubCommandMenuItem
          href={twitterShareUrl(companyUrl(props.company), props.company.name)}
          dataTestId="twitter"
          suppressHydrationWarning
        >
          Xでシェア
        </SubCommandMenuItem>
        <SubCommandMenuItem
          href={facebookShareUrl(companyUrl(props.company))}
          dataTestId="facebook"
          suppressHydrationWarning
        >
          Facebookでシェア
        </SubCommandMenuItem>
      </ul>
    </div>
  )
}

type ItemProps = {
  href: string
  dataTestId: string
  children: ReactNode
  className?: string
  suppressHydrationWarning?: boolean
}
const SubCommandMenuItem: React.FC<ItemProps> = (props) => {
  return (
    <li className={props.className}>
      <a
        href={props.href}
        data-test-id={props.dataTestId}
        target="_blank"
        suppressHydrationWarning={props.suppressHydrationWarning}
        css={css`
          display: flex;
          align-items: center;
          min-height: 40px;
          padding-block: 8px;
          padding-inline: 16px;
          font-size: 14px;
          color: ${colors.text};
          line-height: 1;
          letter-spacing: 0.02em;
          white-space: nowrap;
          :hover {
            background: rgba(0, 0, 0, 0.03);
          }
        `}
      >
        {props.children}
      </a>
    </li>
  )
}
